import React, { Component } from "react";
import { Link } from "react-router-dom";

import RegHold from "../components/registrationHolds";
import Transcript from "../components/transcripts";
import Immunization from "../components/immunization";
import I20 from "../components/I20";
import TAship from "../components/TAship";
import RAship from "../components/RAship";
import Apartment from "../components/apartment";
import StudentOrientation from "../components/studentOrientation";
import OffCampusGuide from "../components/OffCampusGuide";

export default class postAdmission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quickLinks: [
        { name: "Registration Holds", path: "/postAdmission/registration_holds", component: <RegHold /> },
        { name: "Transcripts", path: "/postAdmission/transcripts", component: <Transcript /> },
        { name: "Immunization", path: "/postAdmission/immunization", component: <Immunization /> },
        { name: "I20", path: "/postAdmission/I20_process", component: <I20 /> },
        { name: "TA ship", path: "/postAdmission/TAship", component: <TAship /> },
        { name: "RA ship", path: "/postAdmission/RAship", component: <RAship /> },
        { name: "Off Campus Housing Guide", path: "/postAdmission/offCampusGuide", component: <OffCampusGuide /> },
        { name: "Apartments - accomodations", path: "/postAdmission/apartments", component: <Apartment /> },
        // { name: "VISA", path: "/postAdmission/VISA", component: <Visa /> },
        { name: "Student Orientation", path: "/postAdmission/student_orientation", component: <StudentOrientation /> },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <br />
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={"/"}>Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Post Admission
              </li>
            </ol>
          </nav>
        </div>
        <div className="container">
          <span className="welcome_text">Post Admission</span>
          <hr />
        </div>
        <section className="container">
          <div className="row">
            {this.state.quickLinks.map((item, index) => {
              return (
                <React.Fragment key={"QLinks" + index}>
                  <div className="col text-center">
                    <Link to={item.path} className="btn btn-primary">
                      {item.name}
                    </Link>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
          <hr />
        </section>
        {this.state.quickLinks.map((item, index) => {
          return (
            <React.Fragment key={"PostAdmissionSection" + index}>
              <section className="container">
                <div className="accordion" id={"accordionExample" + index}>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id={"heading" + index}>
                      <button
                        className="accordion-button collapsed text-white bg-warning"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapseIndex" + index}
                        aria-expanded="false"
                        aria-controls={"collapseIndex" + index}
                      >
                        <header className="section_head">{item.name}</header>
                      </button>
                    </h2>
                    <div
                      id={"collapseIndex" + index}
                      className="accordion-collapse collapse"
                      aria-labelledby={"heading" + index}
                      data-bs-parent={"#accordionExample" + index}
                    >
                      <div className="accordion-body">
                        <div className="container accordian_custom_body">{item.component}</div>
                        <div className="container">
                          <Link to={item.path}>Read full ...</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <br />
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  }
}
